import {apiSvg as Icon__small__apiSvg} from '../Icon__small/Icon__small--api.js'
import {apiSvg as Icon__xsmall__apiSvg} from '../Icon__xsmall/Icon__xsmall--api.js'

export var api = {
  name: 'api',
  category: 'icon',
  colorable: true,
  svg: Icon__small__apiSvg,
  alt: {
    Icon__small: Icon__small__apiSvg,
    Icon__xsmall: Icon__xsmall__apiSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
